import { render } from "./sliding_tabs.vue?vue&type=template&id=70921aee"
import script from "./sliding_tabs.vue?vue&type=script&lang=js"
export * from "./sliding_tabs.vue?vue&type=script&lang=js"

import "./sliding_tabs.vue?vue&type=style&index=0&id=70921aee&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__